import {MODULE_NAME} from './slice';

export const selectSamples = (state) => ({
    loading: state[MODULE_NAME].loading,
    error: state[MODULE_NAME].error,
    data: state[MODULE_NAME].samples,
  });

export const formStatus = (state) => ({
  submitting: state[MODULE_NAME].submitting
})
